import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-bw",
  "use": "icon-icon-bw-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" id=\"icon-icon-bw\">\n  <g fill-rule=\"evenodd\">\n    <path fill=\"#00cbff\" d=\"M0 0h512v512H0z\" />\n    <path fill=\"#fff\" d=\"M0 192h512v128H0z\" />\n    <path d=\"M0 212.7h512V299H0z\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol